import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7122ec30")

_pushScopeId("data-v-7122ec30")
const _hoisted_1 = { class: "table-bg" }
const _hoisted_2 = { class: "p-d-flex p-ai-end" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = {
  key: 0,
  class: "p-mr-2 badge bg-red"
}
const _hoisted_5 = {
  key: 1,
  class: "p-mr-2 badge bg-green"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("-")
_popScopeId()

import { client } from '@/api/client-v2';
import { useStore } from '@/store/store';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { formatDateDDMMYYYY } from '@/services/dates.service';
import { UserByClub } from '@/api/types';
import Column from 'primevue/column';
import BanUserModal from '@/components/users-list/BanUserModal.vue';
import FilterUsers, { Filter } from './FilterUsers.vue';
import { useI18n } from 'vue-i18n';
import { showToast } from '@/services/error-management.service';


export default _defineComponent({
  props: {
    maskUsersData: { type: Boolean, required: false }
  } as unknown as undefined,
  setup(__props: {
  maskUsersData?: boolean;
}) {

const props = __props
const LIMIT = 15;

const { t } = useI18n();
const store = useStore();

const users = ref<UserByClub['users']>()
const total = ref(0);
const page = ref(1);
const loading = ref(false);
const first = computed(() => (page.value - 1) * LIMIT);



const filters = reactive<Filter>({
  min_cancellations: undefined,
  min_bookings: undefined,
  banned: null,
  name: undefined,
})


/* COMPUTED */
const myClubId = computed(() => {
  return store.getters.getMyClub.club_id;
});

// TODO: remove the masking on the client side as soon as the API supports it
const maskEmail = (email?: string) => {
  if (!email) return email;
  const parts = email.split("@");
  if (parts.length !== 2) return email;

  const namePart = parts[0];
  const domainPart = parts[1].split(".");
  const domain = domainPart.pop();

  return `${namePart.slice(0, 3)}*****@*****.${domain}`;
}

const maskPhone = (phone?: string) => {
  if (!phone) return phone;
  return phone.slice(0, 6) + "*****";
}


const getUsers = async () => {
  try {
    loading.value = true;
    const { data } = await client.getUsersByClubId({
      clubId: myClubId.value,
      page: page.value,
      limit: LIMIT,
      filters,
    });
    if (props.maskUsersData) {
      users.value = data.users.map((user) => ({
        ...user,
        user: {
          ...user.user,
          email: maskEmail(user.user.email),
          cell: maskPhone(user.user.cell),
        }
      }));
    } else {
      users.value = data.users;
    }
    total.value = data.pagination.total;
  } catch (error) {
    console.error('Error fetching users:', error);
    users.value = [];
    total.value = 0;
    page.value = 1;
    showToast('si è verificato un errore')
  } finally {
    loading.value = false;
  }
}

const pageEvent = (event: { page: number }) => {
  page.value = event.page + 1;
  getUsers();
}

const searchFromFirstPage = () => {
  page.value = 1;
  getUsers();
}

onMounted(() => {
  getUsers()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      value: users.value,
      lazy: "",
      paginator: "",
      rows: 15,
      "page-link-size": 10,
      first: _unref(first),
      "total-records": total.value,
      loading: loading.value,
      onPage: pageEvent,
      size: "large",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
      currentPageReportTemplate: "{first} a {last} di {totalRecords} utenti",
      paginatorPosition: "top"
    }, {
      paginatorLeft: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(FilterUsers, {
            filters: _unref(filters),
            "onUpdate:filters": [
              _cache[1] || (_cache[1] = ($event: any) => (_isRef(filters) ? filters.value = $event : filters = $event)),
              searchFromFirstPage
            ]
          }, null, 8, ["filters"])
        ])
      ]),
      empty: _withId(() => [
        _createVNode("p", null, _toDisplayString(_unref(t)('no_records')), 1)
      ]),
      default: _withId(() => [
        _createVNode(_unref(Column), {
          header: _unref(t)('name') + ' ' + _unref(t)('surname')
        }, {
          body: _withId((slotProps) => [
            _createVNode("div", _hoisted_3, [
              (slotProps.data.banned)
                ? (_openBlock(), _createBlock("span", _hoisted_4))
                : (_openBlock(), _createBlock("span", _hoisted_5)),
              _createVNode(_component_router_link, {
                to: { name: 'user-details', params: { id: slotProps.data.id } },
                class: "color-blue p-text-bold underline"
              }, {
                default: _withId(() => [
                  (slotProps.data.user)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(slotProps.data.user.nome) + " " + _toDisplayString(slotProps.data.user.cognome), 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _hoisted_6
                      ], 64))
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          header: _unref(t)('gender')
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.user?.gender), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          header: _unref(t)('birthdate')
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(_unref(formatDateDDMMYYYY)(slotProps.data.user?.dataDiNascita)), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          header: _unref(t)('email')
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.user?.email), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          header: _unref(t)('phonenumber_abbreviated')
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.user?.cell), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_unref(Column), {
          field: "bookings_count",
          header: _unref(t)('bookings')
        }, null, 8, ["header"]),
        _createVNode(_unref(Column), {
          field: "cancellations_count",
          header: _unref(t)('rejects')
        }, null, 8, ["header"]),
        _createVNode(_unref(Column), { field: "actions" }, {
          body: _withId((slotProps) => [
            _createVNode(BanUserModal, {
              user: slotProps.data.user,
              "user-id": slotProps.data.id,
              "is-banned": slotProps.data.banned,
              onUserUpdated: getUsers
            }, null, 8, ["user", "user-id", "is-banned"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "first", "total-records", "loading"])
  ]))
}
}

})